// Mock content data extracted from absolutedocks.com structure
// (Brand visual + name preserved per attached logo asset)

export const BRAND = {
  name: 'Absolute',
  sub: 'Dock & Boat Lift',
  tagline: 'Fort Myers, FL',
};

export const NAV_ITEMS = [
  { label: 'Options & Specs', shortLabel: 'Specs', href: '#specs' },
  { label: 'The Hammer', href: '#hammer' },
  { label: 'Why Us', href: '#why' },
  { label: 'Delivery Options', shortLabel: 'Delivery', href: '#coverage' },
  { label: 'Financing', href: '#financing' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
];

export const SERVICES = [
  {
    icon: 'Hammer',
    title: 'New Dock Construction',
    body:
      'Custom dock builds from the ground up — complete with framing, decking in wood, economy composite, or premium composite / wear deck materials.',
  },
  {
    icon: 'Wrench',
    title: 'Dock Renovation & Repair',
    body:
      'Full and partial renovations, pile replacement, deck replacement, and structural repairs to restore your dock to perfect condition.',
  },
  {
    icon: 'Anchor',
    title: 'Boat Lift Installation',
    body:
      'Aluminum direct-drive boat lifts from 6K to 40K lbs. Traditional, pontoon, and tritoon configurations with all accessories.',
  },
  {
    icon: 'Sailboat',
    title: 'PWC & Jet Ski Lifts',
    body:
      'Jet ski and PWC lifts — piling mount and seawall mount options available. 12\u2032 and 15\u2032 configurations to suit your waterway.',
  },
  {
    icon: 'Pickaxe',
    title: 'Demolition & Removal',
    body:
      'Efficient demolition of old docks, decks, and frames. Pile removal for 8\u201d and 10\u201d pilings, and complete boat lift removal.',
  },
  {
    icon: 'FileCheck2',
    title: 'Permits & Compliance',
    body:
      'We handle city permits, FWC permits, and homeowner permits — keeping your project 100% compliant with Florida regulations.',
  },
];

export const REASONS = [
  {
    icon: 'Zap',
    title: 'Fast Turnaround',
    body: 'We build our barges in 60 days or less and keep you posted on progress throughout the whole process.',
  },
  {
    icon: 'BadgeDollarSign',
    title: 'Transparent Pricing',
    body:
      'Each feature on our barges has a fair and transparent price — no upcharges, no sneaky sales tricks that make you pay more later. Just honest pricing for each item without the BS.',
  },
  {
    icon: 'Flag',
    title: 'Made in the U.S.A.',
    body:
      'Our barges are proudly designed & built right here in Fort Myers, Florida.',
  },
  {
    icon: 'HardHat',
    title: 'Real Marine Contractors',
    body:
      'Southwest Florida marine contractors using our barges every day. We don\'t just build them, we use them, test them, and improve them.',
  },
  {
    icon: 'BadgeCheck',
    title: 'Manufacturing Warranty',
    body:
      'Our barges come with a full 2-year warranty on the hulls that we build because we are confident in our design and construction quality.',
  },
  {
    icon: 'Diamond',
    title: 'The HDPE Guarantee',
    body:
      'If you have any concerns about the use of HDPE as a barge material or the construction quality and are a serious buyer, we will fly you down to Fort Myers — or deduct the cost of your flight from your deposit — to test it out in person for yourself.',
  },
];

export const COVERAGE = [
  'Cape Coral',
  'Fort Myers',
  'Fort Myers Beach',
  'Bonita Springs',
  'Naples',
  'Marco Island',
  'Sanibel Island',
  'Captiva',
  'Estero',
  'Lehigh Acres',
  'Pine Island',
  'North Fort Myers',
];

export const STATS = [
  { value: '8×24 / 10×30', label: 'Available Hull Sizes' },
  { value: 'Single / Twin', label: 'Suzuki 115 Power Options' },
  { value: '15K / 18K', label: 'Rated Payload (lbs)' },
  { value: 'HDPE', label: 'Never Crack or Rust' },
];

export const HERO_CUES = [
  {
    eyebrow: 'HDPE BARGE',
    title: 'Built for work.',
    body: '',
  },
  {
    eyebrow: 'TWIN SUZUKI 115',
    title: 'Engineered to last.',
    body: '',
  },
  {
    eyebrow: 'ON THE WATER NOW',
    title: 'Absolute precision.',
    body: '',
  },
];

export const CONTACT = {
  phones: [
    { name: 'Vince (Sales)', number: '(941) 275-2692', tel: '+19412752692' },
    { name: 'Wanderson', number: '(321) 477-4498', tel: '+13214774498' },
    { name: 'Maiky', number: '(321) 477-4970', tel: '+13214774970' },
  ],
  salesPhone: { name: 'Vince (Sales)', number: '(941) 275-2692', tel: '+19412752692' },
  instagram: '@absolutedocks',
  instagramUrl: 'https://instagram.com/absolutedocks',
  email: 'absolutebargesales@gmail.com',
  area: 'Fort Myers, FL — and all of Southwest Florida',
};
